import React from 'react';
import {
  Box,
  Button,
  Modal,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from './CheckIcon';

import { classes } from './styles';
import { StyledSnackbarProps } from '../../../Components/CustomUIElements/StyledSnackbar';
import RecruitApiClient from '../../../../RecruitApiClient';
import { modalTextCopy } from './modalTextCopy';
import LoadingButton from '../../../Components/Buttons/LoadingButton';
import { getCurrentRegion } from '../../../utils/regionUtils';

type Props = {
  jobId: number;
  applicationIds: number[];
  close: () => void;
  setSnackbar: StyledSnackbarProps['setSnackbarState'];
};

const RequestPreEmploymentCheck = ({ close, setSnackbar, jobId, applicationIds }: Props) => {
  const region = getCurrentRegion();

  const handleRequest = async () => {
    await RecruitApiClient.post('/api/v4/app_services/preemployment_check', {
      job_id: jobId,
      application_ids: applicationIds
    });
    setSnackbar({
      state: 'success',
      message: 'Thanks for your request! A member of our team will reach out shortly.'
    });
    close();
  };

  return (
    <Modal open onClose={close}>
      <Box sx={classes.modalContent}>
        <Box sx={classes.container}>
          <Typography color="#084D6D" variant="h5" fontWeight={700} marginBottom="24px">
            Request pre-employment check
          </Typography>
          <CloseIcon
            id="close-request-pre-employment-check-modal-button"
            onClick={close}
            sx={classes.closeIcon}
          />
          <Typography variant="subtitle2">
            {modalTextCopy[region].top}
          </Typography>
          <List>
            {modalTextCopy[region].bulletPoints.map((text) => (
              <ListItem key={text}>
                <ListItemIcon sx={{ minWidth: '35px' }}>
                  <CheckIcon />
                </ListItemIcon>
                <ListItemText>
                  <Typography sx={{ fontWeight: 600 }}>{text}</Typography>
                </ListItemText>
              </ListItem>
            ))}
          </List>
          <Typography variant="subtitle2">
            {modalTextCopy[region].bottom}
          </Typography>
          <Box sx={classes.modalActions}>
            <Button disableElevation variant="text" sx={classes.buttonRedLight} onClick={close}>
              Cancel
            </Button>
            <LoadingButton sx={classes.requestButton} task={handleRequest}>
              Request
            </LoadingButton>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default RequestPreEmploymentCheck;
